var _path, _path2, _g, _path3, _path4, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39971 12C1.36614 12 0 10.5737 0 8.45057V3.55003C0 1.42687 1.36614 0 3.39971 0H8.60029C10.6339 0 12 1.42687 12 3.55003V8.45057C12 10.5737 10.6339 12 8.59969 12H3.39971Z",
    fill: "url(#paint0_linear_3071_17421)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3071_17421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39971 12C1.36614 12 0 10.5737 0 8.45057V3.55003C0 1.42687 1.36614 0 3.39971 0H8.60029C10.6339 0 12 1.42687 12 3.55003V8.45057C12 10.5737 10.6339 12 8.59969 12H3.39971Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3071_17421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#paint1_linear_3071_17421)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16399 3.76176C5.16399 4.59488 4.49126 5.27292 3.66468 5.27292C2.83749 5.27292 2.16536 4.59488 2.16536 3.76176C2.16536 2.92865 2.83749 2.25 3.66468 2.25C4.49126 2.25 5.16399 2.92865 5.16399 3.76176ZM10.0848 7.05313C10.2254 7.19056 10.3261 7.34745 10.3925 7.51469C10.5934 8.02063 10.489 8.62874 10.2742 9.12983C10.0196 9.72639 9.53212 10.177 8.91791 10.374C8.6452 10.4622 8.35921 10.4999 8.07383 10.4999H3.01719C2.514 10.4999 2.06873 10.3819 1.7037 10.1606C1.47503 10.0219 1.43461 9.70267 1.60415 9.4947C1.88772 9.14807 2.16768 8.80023 2.45004 8.44935C2.98823 7.778 3.35084 7.5834 3.75387 7.75428C3.91738 7.82482 4.08149 7.93124 4.25043 8.04313C4.70052 8.34354 5.32619 8.75584 6.15036 8.30827C6.71372 7.99779 7.04074 7.4665 7.32537 7.00407L7.33111 6.99475C7.35027 6.9638 7.36926 6.93287 7.3882 6.90202C7.48498 6.7444 7.58031 6.58915 7.68829 6.44623C7.82223 6.26927 8.31939 5.71589 8.96196 6.10995C9.37163 6.35806 9.71614 6.69374 10.0848 7.05313Z",
    fill: "url(#paint2_linear_3071_17421)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3071_17421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 10,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16399 3.76176C5.16399 4.59488 4.49126 5.27292 3.66468 5.27292C2.83749 5.27292 2.16536 4.59488 2.16536 3.76176C2.16536 2.92865 2.83749 2.25 3.66468 2.25C4.49126 2.25 5.16399 2.92865 5.16399 3.76176ZM10.0848 7.05313C10.2254 7.19056 10.3261 7.34745 10.3925 7.51469C10.5934 8.02063 10.489 8.62874 10.2742 9.12983C10.0196 9.72639 9.53212 10.177 8.91791 10.374C8.6452 10.4622 8.35921 10.4999 8.07383 10.4999H3.01719C2.514 10.4999 2.06873 10.3819 1.7037 10.1606C1.47503 10.0219 1.43461 9.70267 1.60415 9.4947C1.88772 9.14807 2.16768 8.80023 2.45004 8.44935C2.98823 7.778 3.35084 7.5834 3.75387 7.75428C3.91738 7.82482 4.08149 7.93124 4.25043 8.04313C4.70052 8.34354 5.32619 8.75584 6.15036 8.30827C6.71372 7.99779 7.04074 7.4665 7.32537 7.00407L7.33111 6.99475C7.35027 6.9638 7.36926 6.93287 7.3882 6.90202C7.48498 6.7444 7.58031 6.58915 7.68829 6.44623C7.82223 6.26927 8.31939 5.71589 8.96196 6.10995C9.37163 6.35806 9.71614 6.69374 10.0848 7.05313Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3071_17421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "url(#paint3_linear_3071_17421)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3071_17421",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3071_17421",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3071_17421",
    x1: 1.5,
    y1: 2.25,
    x2: 1.5,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3071_17421",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 10.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.95391980.svg";
export { ForwardRef as ReactComponent };